import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonModal,
  IonPage,
  IonProgressBar,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { BleService } from 'src/ble/BleService';
import { selectBleReadLog } from 'src/redux/ble/selectors';

interface ControllerDevLogFileViewerProps {
  /** The file to view. */
  filename?: string;
  /** Called when the user closes the view. */
  onClose: () => void;
}

export const ControllerDevLogFileViewer: React.FC<ControllerDevLogFileViewerProps> = props => {
  const readLogState = useSelector(selectBleReadLog);

  React.useEffect(() => {
    if (BleService.controller?.readLog && props.filename) BleService.controller.readLog(props.filename);
  }, [props.filename]);

  const progress = React.useMemo(() => {
    if (!readLogState) return undefined;
    return readLogState.readBytes / readLogState.totalBytes;
  }, [readLogState]);

  return (
    <IonModal isOpen={!!props.filename} onDidDismiss={props.onClose}>
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{props.filename}</IonTitle>
            <IonButton size="small" slot="end" onClick={props.onClose}>
              Close
            </IonButton>
          </IonToolbar>
          {progress !== undefined && <IonProgressBar value={progress} />}
        </IonHeader>
        <IonContent>
          <code>{readLogState?.data}</code>
        </IonContent>
        <IonFooter>
          <IonToolbar />
        </IonFooter>
      </IonPage>
    </IonModal>
  );
};
